/* global process, __honeybadgerContext */

/* JS bundle for the public web pages. */

// Honeybadger setup
import Honeybadger from "@honeybadger-io/js"
Honeybadger.configure({
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: process.env.RAILS_ENV,
  maxErrors: 20,
  enableUnhandledRejection: false,
  endpoint: "https://eu-api.honeybadger.io"
})
if (typeof __honeybadgerContext !== "undefined") {
  Honeybadger.setContext(__honeybadgerContext)
}
Honeybadger.beforeNotify((notice) => {
  return !notice.backtrace.some((trace) => /https?:\/\//.test(trace.file) &&
    !/nejremeslnici\.cz|nere\.cz/.test(trace.file)) &&
    !notice.message.match("Module specifier.* does not start with")
})
window.Honeybadger = Honeybadger

import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false

// Custom Turbo Stream action for redirecting out of Turbo Frames
// https://www.ducktypelabs.com/turbo-break-out-and-redirect/
Turbo.StreamActions.redirect_to = function () {
  window.location = this.target // use Turbo.visit(this.target) instead when Turbo Drive ready
}

Turbo.StreamActions.set_attribute = function () {
  const value = this.getAttribute("value") || ""
  const attribute = this.getAttribute("attribute")

  this.targetElements.forEach((el) =>
    el.setAttribute(attribute, value)
  )
}

// Track Content Missing Turbo errors
document.addEventListener("turbo:frame-missing", (event) => {
  response = event.detail.response

  if (response.status < 200 || response.status >= 300) { // ignore errors
    return
  }

  response.text().then((text) => {
    Honeybadger.notify("turbo:frame-missing " + event.target.id, {
      context: {
        frame_id: event.target.id,
        response: { url: response.url, status: response.status, body: text }
      }
    })
  })
})
